(async () => {
  'use strict';
 if (location.hash === '#subscription-help') return;
  const root = document.getElementById('fs-mobile-funnel');
  if (!root) return;
  const catalog=await (window.fsCatalogReady || Promise.resolve(null));
  const product=window.fsCatalogProduct;
  const price=cents=>'$'+(cents/100).toFixed(cents%100?2:0);
  const key = 'fs-mobile-funnel-v1'+(product?':'+product:'');
  let state = {step: 1, plan: null, preview: false};
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
    state.plan = ['monthly', 'bundle'].includes(saved.plan) ? saved.plan : null;
    state.step = [1,2,3].includes(saved.step) ? saved.step : 1;
    if (state.step === 3 && !state.plan) state.step = 2;
  } catch (_) {}
  const checkoutHost = location.hostname === 'checkout.futureselfrx.ai';
  const requestedPlan = new URLSearchParams(location.search).get('plan');
  if (checkoutHost && ['monthly','bundle'].includes(requestedPlan)) { state.plan=requestedPlan; state.step=3; }
  if(catalog){
    state.step=['monthly','bundle'].includes(requestedPlan)?3:2;state.plan=['monthly','bundle'].includes(requestedPlan)?requestedPlan:null;
    const m=catalog.plans.monthly,b=catalog.plans.bundle;
    root.querySelector('[data-show="isStep1"]').remove();
    root.querySelectorAll('.fs-vials').forEach(e=>e.remove());
    const month=root.querySelector('[data-action="chooseMonthly"]'),bundle=root.querySelector('[data-action="chooseBundle"]');
    month.querySelector('.fs-price').textContent=price(m.initial_cents)+' today';month.querySelector('.fs-plan-copy').textContent='First month, then '+price(m.renewal_cents)+'/month. Monthly subscription.';
    bundle.querySelector('.fs-price').textContent=price(b.initial_cents)+' today';bundle.querySelector('.fs-plan-copy').textContent='About '+price(Math.round(b.initial_cents/3))+' per month. One-time payment. No renewal.';
    bundle.querySelector('.fs-save').textContent='Save '+price(m.initial_cents+2*m.renewal_cents-b.initial_cents)+' over the first three months';
    const section=root.querySelector('[data-show="isStep2"]');section.querySelector('h1').textContent=m.name.replace(' — monthly','');
    section.querySelectorAll('p').forEach(e=>{if(!e.closest('.fs-plan') && /149|79|299|78/.test(e.textContent))e.textContent='Monthly: '+price(m.initial_cents)+' today, then '+price(m.renewal_cents)+'/month. Three months: '+price(b.initial_cents)+' once. Medication ships only if prescribed.';});
  }
  let returnFocus;
  const render = () => {
    const bundle = state.plan === 'bundle', chosen = !!state.plan;
    const values = {
      isStep1: state.step === 1, isStep2: state.step === 2, isStep3: state.step === 3,
      withDaily: true, withFaq: true, withBadge: true, previewOpen: state.preview,
      monthlyAria: String(state.plan === 'monthly'), bundleAria: String(bundle),
      monthlyDot: state.plan === 'monthly' ? '✓' : '', bundleDot: bundle ? '✓' : '',
      monthlyDotBg: state.plan === 'monthly' ? '#48634d' : 'transparent', bundleDotBg: bundle ? '#48634d' : 'transparent',
      continueDisabled: !chosen, continueBg: chosen ? '#232323' : '#e4e8e1', continueFg: chosen ? '#ffffff' : '#5e6758',
      continueLabel: chosen ? 'Continue · ' + (catalog ? price(catalog.plans[bundle?'bundle':'monthly'].initial_cents) : (bundle ? '$299' : '$79')) + ' today' : 'Select a plan to continue',
      planName: catalog ? catalog.plans[bundle?'bundle':'monthly'].name : (bundle ? '3-month starter bundle' : 'Monthly starter'), planPrice: catalog ? price(catalog.plans[bundle?'bundle':'monthly'].initial_cents) : (bundle ? '$299' : '$79'),
      planTerms: catalog ? (bundle ? 'One-time package. '+price(catalog.plans.bundle.initial_cents)+' today. No renewal.' : 'Then '+price(catalog.plans.monthly.renewal_cents)+'/month. Cancel future renewals before your next billing date.') : bundle ? 'One-time starter package. $299 charged today.' : 'Then $149/month. Cancel future renewals before your next billing date.'
    };
    root.querySelectorAll('[data-show]').forEach(el => { el.hidden = !values[el.dataset.show]; });
    root.querySelectorAll('[data-text]').forEach(el => { el.textContent = values[el.dataset.text]; });
    ['style','aria-pressed','disabled'].forEach(attr => {
      root.querySelectorAll('[data-bind-' + attr + ']').forEach(el => {
        const source = el.getAttribute('data-bind-' + attr);
        if (attr === 'disabled') el.disabled = values.continueDisabled;
        else el.setAttribute(attr, source.replace(/\[\[(\w+)\]\]/g, (_,name) => values[name]));
      });
    });
    document.dispatchEvent(new CustomEvent('fs:funnel-state',{detail:{step:state.step,plan:state.plan}}));
    const modal = root.querySelector('[role="dialog"]');
    root.querySelectorAll('[data-show="isStep1"],[data-show="isStep2"],[data-show="isStep3"]').forEach(el => { el.inert = state.preview; });
    document.body.style.overflow = state.preview ? 'hidden' : '';
    if (state.preview) modal.querySelector('button').focus();
    try { sessionStorage.setItem(key, JSON.stringify({step: state.step, plan: state.plan})); } catch (_) {}
  };
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-action]');
    if (!button) return;
    const previous = state.step;
    switch (button.dataset.action) {
      case 'next': state.step = 2; break;
      case 'back': state.step = Math.max(catalog?2:1, state.step - 1); break;
      case 'chooseMonthly': state.plan = 'monthly'; break;
      case 'chooseBundle': state.plan = 'bundle'; break;
      case 'continuePlan': if (state.plan && !checkoutHost && !catalog) { location.href=window.fsCheckoutUrl?window.fsCheckoutUrl(state.plan):'https://checkout.futureselfrx.ai/pages/mobile-funnel?plan='+state.plan; return; } if (state.plan) state.step = 3; break;
      case 'openPreview': returnFocus = button; state.preview = true; break;
      case 'closePreview': state.preview = false; break;
      case 'restart': state = {step: catalog?2:1, plan: null, preview: false}; root.querySelectorAll('input').forEach(el => { el.value = ''; }); break;
    }
    render();
    if (previous !== state.step) {
      window.scrollTo({top: 0, behavior: 'instant'});
      const heading = root.querySelector('[data-show="isStep' + state.step + '"] h1');
      heading.tabIndex = -1; heading.focus({preventScroll: true});
    } else if (!state.preview && button.dataset.action === 'closePreview') returnFocus?.focus();
  });
  root.addEventListener('keydown', event => {
    if (!state.preview) return;
    if (event.key === 'Escape') { state.preview = false; render(); returnFocus?.focus(); }
    if (event.key === 'Tab') {
      const buttons = root.querySelectorAll('[role="dialog"] button');
      if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons[1].focus(); }
      else if (!event.shiftKey && document.activeElement === buttons[1]) { event.preventDefault(); buttons[0].focus(); }
    }
  });
  render();
})();
